import React from 'react';
import {Carousel, CarouselItem} from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css'

import carrusel_0 from '../../icons/img/carrusel/1.jpg'
import carrusel_1 from '../../icons/img/carrusel/2.jpg'
import carrusel_2 from '../../icons/img/carrusel/3.jpg'
import carrusel_3 from '../../icons/img/carrusel/4.jpg'
import carrusel_4 from '../../icons/img/carrusel/5.jpg'
import carrusel_5 from '../../icons/img/carrusel/6.jpg'
import carrusel_6 from '../../icons/img/carrusel/7.jpg'
import carrusel_7 from '../../icons/img/carrusel/8.jpg'
import carrusel_8 from '../../icons/img/carrusel/9.jpg'
import carrusel_9 from '../../icons/img/carrusel/10.jpg'
import carrusel_10 from '../../icons/img/carrusel/11.jpg'
import carrusel_11 from '../../icons/img/carrusel/12.jpg'
import carrusel_12 from '../../icons/img/carrusel/13.jpg'
import {IStore} from "../../store/reducers";
import actionTypes from "../../store/actionTypes";
import {connect} from "react-redux";
import './carrusel_style.css'


const items = [
    {
        src: carrusel_0,
        altText: 'carrusel_0',
        caption: '0'
    },
    {
        src: carrusel_1,
        altText: 'carrusel_1',
        caption: '1'
    },
    {
        src: carrusel_2,
        altText: 'carrusel_2',
        caption: '2'
    },
    {
        src: carrusel_3,
        altText: 'carrusel_3',
        caption: '3'
    },
    {
        src: carrusel_4,
        altText: 'carrusel_4',
        caption: '4'
    },
    {
        src: carrusel_5,
        altText: 'carrusel_5',
        caption: '5'
    },
    {
        src: carrusel_6,
        altText: 'carrusel_6',
        caption: '6'
    },
    {
        src: carrusel_7,
        altText: 'carrusel_7',
        caption: '7'
    },
    {
        src: carrusel_8,
        altText: 'carrusel_8',
        caption: '8'
    },
    {
        src: carrusel_9,
        altText: 'carrusel_9',
        caption: '9'
    },
    {
        src: carrusel_10,
        altText: 'carrusel_10',
        caption: '10'
    },
    {
        src: carrusel_11,
        altText: 'carrusel_11',
        caption: '11'
    },
    {
        src: carrusel_12,
        altText: 'carrusel_12',
        caption: '12'
    },
];


interface IProps {
}

interface IState {
    animating: boolean
    activeIndex: number,
    miliseconds: number
}

class Carrusel extends React.Component<IProps, IState> {

    state: IState = {
        animating: false,
        activeIndex: 1,
        miliseconds: 5000
    }

    componentDidMount() {
        setTimeout(() => this.next(), this.state.miliseconds)
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }

    onExiting() {
        this.state.animating = true;
    }

    onExited() {
        this.state.animating = false;
    }

    next() {
        if (this.state.animating) return;
        const nextIndex = this.state.activeIndex === items.length - 1 ? 0 : this.state.activeIndex + 1;
        this.setState({ activeIndex: nextIndex });
    }

    previous() {
        if (this.state.animating) return;
        const nextIndex = this.state.activeIndex === 0 ? items.length - 1 : this.state.activeIndex - 1;
        this.setState({ activeIndex: nextIndex });
    }

    goToIndex(newIndex: number) {
        if (this.state.animating) return;
        this.setState({ activeIndex: newIndex });
    }

    render() {

        const slides = items.map((item) => {
            return (
                <CarouselItem
                    onExiting={() => this.onExiting()}
                    onExited={() => this.onExited()}
                    key={item.src}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: window.screen.width/2,
                            height: window.screen.height,
                            justifyContent: "center"
                        }}
                    >
                        <img
                            style={{
                                width: '100%'
                            }}
                            src={item.src}
                            alt={item.altText}
                        />
                    </div>
                </CarouselItem>
            );
        });

        return (
            <div>
                <Carousel
                    activeIndex={this.state.activeIndex}
                    next={() => this.next()}
                    previous={() => this.previous()}
                    keyboard={false}
                    interval={this.state.miliseconds}
                    slide={false}
                    className="carousel-fade"
                >
                    {slides}
                </Carousel>
            </div>
        );
    }
}


const mapStateToProps = (state: IStore) => ({
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
});


export default connect(mapStateToProps, mapDispatchToProps)(Carrusel);
